<template>
  <div class="">
    <div class="row">
      <div class="col-12 col-md-5">
        <documents-send-mail-form
          :documentData="salesInvoice"
          :dispatchUrl="'salesInvoices/sendMail'"
          :toggleMailModal="toggleMailModal"
          :mailInformation="mailInformation"
        />
      </div>
      <div class="col-12 col-md-7" style="max-height: 100%">
        <sales-invoice-view-details
          :showHeader="false"
          :salesInvoice="salesInvoice"
          @salesInvoiceItemsUpdated="get"
        />
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <el-button type="danger" @click="toggleMailModal">
        {{ $t("COMMON.CANCEL") }}
      </el-button>
    </div>
  </div>
</template>
<script>
import { Button } from "element-ui";
import "flatpickr/dist/flatpickr.css";
import formMixin from "@/mixins/form-mixin";
import DocumentsSendMailForm from "@/components/DocumentsSendMailForm";
import SalesInvoiceViewDetails from "./SalesInvoiceViewDetails.vue";

export default {
  layout: "DashboardLayout",
  name: "sales-invoice-mail-modal-content",

  components: {
    DocumentsSendMailForm,
    [Button.name]: Button,
    SalesInvoiceViewDetails,
  },

  mixins: [formMixin],
  props: {
    salesInvoice: {
      default: () => {},
    },
    toggleMailModal: {
      type: Function,
    },
    get: {
      type: Function,
    },
    loading: {
      default: () => true,
    },
  },

  data() {
    return {
      submitting: false,
      mailInformation: {
        organization: {},
        recipient: {},
        user: {},
      },
    };
  },

  created() {},

  mounted() {
    this.refreshMailInformations();
  },

  methods: {
    refreshMailInformations() {
      this.user = this.$store.getters["profile/me"];

      this.mailInformation = {
        organization: this.salesInvoice.organization,
        subject: this.$t("COMMON.EMAIL_INFOS_SUBJECT_INVOICE", {
          organization: this.salesInvoice.organization?.name,
          seq_number: this.salesInvoice.seq_number,
        }),
        recipient: {
          username: this.salesInvoice?.recipient?.customer_name,
          email:
            this.salesInvoice?.recipient?.billing_email ??
            this.salesInvoice?.recipient?.email,
        },
        body: this.$t("COMMON.SALES_INVOICE_EMAIL_INFOS_BODY", {}),
      };
    },
  },

  watch: {
    salesInvoice(salesInvoice) {
      this.refreshMailInformations();
    },
  },
};
</script>
